module.exports = __webpack_public_path__ + "media/images/front/medical_leaders/logo-1c7ca34658cc3b084a4e23f72db9265a.svg";